module.exports = __webpack_public_path__ + "img/AWAKEN-Landing_page-laurel-if3.3bb9d8d.png";